export default "__VITE_ASSET__3280eaa0__"